<template>
    <section v-if="category != null">
        <h2 class="hide">{{category.categoryName}} ({{boardListFilter.length}})</h2>
        <div class="tb-header clear">
            <div class="tb_sort fr">
                <input type="checkbox" :id="'new_'+category.categoryMid" v-model="noneRead">
                    <label :for="'new_'+category.categoryMid">{{ $i18nUtil.trans("button.sharPaper.unread","미확인 보드 보기") }}</label>
                <input type="checkbox" :id="'fav_'+category.categoryMid" v-model="filterBookmark">
                    <label :for="'fav_'+category.categoryMid">{{ $i18nUtil.trans("button.favorite","즐겨찾기 보기") }}</label>
                <div class="dropdown relative ty2">
                    <v-menu bottom left>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on">{{selectSort}}</v-btn>
                        </template>
                        <div class="dropdown-list">
                            <div class="dropdown-list-item">
                                <div class="tit">
                                    <button type="button" class="active" value="lastest" :name="$i18nUtil.trans('entity.paper.search.sort.update', '최신순')" @click="fSelectSort($event)">{{ $i18nUtil.trans("entity.paper.search.sort.update","최신순") }}</button>
                                </div>
                            </div>
                            <div class="dropdown-list-item">
                                <div class="tit">
                                    <button type="button" value="views" :name="$i18nUtil.trans('entity.paper.search.sort.views', '조회수순')" @click="fSelectSort($event)">{{ $i18nUtil.trans("entity.paper.search.sort.views","조회수순") }}</button>
                                </div>
                            </div>
                            <div class="dropdown-list-item">
                                <div class="tit">
                                    <button type="button" value="like" :name="$i18nUtil.trans('entity.paper.search.sort.like', '좋아요순')" @click="fSelectSort($event)">{{ $i18nUtil.trans("entity.paper.search.sort.like","좋아요순") }}</button>
                                </div>
                            </div>
                        </div>
                    </v-menu>
                </div> 
                <div class="dividing_line_ty1"></div>
                <CommonFilterE :filterReset="false" :ignoreChineseWallUse="true" @updateCommonFilterE="updateCommonFilterE"/> 
                <div class="droplayer icon setting large right nosel">
                    <v-menu bottom left>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on">설정</v-btn>
                        </template>
                        <div class="dropdown-list">
                            <div class="dropdown-list-item" v-if="shareInfoManageYn || categoryManageYn" >
                                <div class="tit">
                                    <router-link :to="{ name: 'shareInfoManage' }"  > 
                                        <button type="button">{{ $i18nUtil.trans("title.ShareInfoManageHeader.001","정보공유 카테고리 관리") }}</button>
                                    </router-link>
                                   
                                </div>
                            </div>
                            <div class="dropdown-list-item">
                                <div class="tit">
                                    <!-- <router-link :to="{ name: 'shareInfoBoardManage' }"> -->
                                        <button type="button" @click="goBoardManage">{{ $i18nUtil.trans("title.ShareInfoBoardManageHeader.001","정보공유 보드 관리") }}</button>
                                    <!-- </router-link> -->
                                </div>
                            </div>
                        </div>
                    </v-menu>
                </div>
                <div class="dividing_line_ty1"></div>
                <button type="button" class="btn-primary-small black" @click="addBoard">{{ $i18nUtil.trans("button.paper.shar.add","정보 보드 추가") }}</button>
            </div>
        </div><!-- //tb-header -->
        <div class="division">
            <div class="sub_tit_box clear">
                <h3 class="fl ell-singleline" style="max-width: calc(95%); display: block;">{{category.categoryName}}</h3>
                <h3>&nbsp;&nbsp;({{boardListFilter.length}})</h3>
            </div>
            <ul class="list-card_square col-4">
                <li v-for="(board , index ) in boardListFilter" :key="'shareBoard_'+index" >
                    <div class="list-top">
                        <div class="list-top clear">
                            <!-- <div class="list-team fl">미래전략실</div> -->
                            <div class="btn_top hover fr">
                                <button type="button" class="ico-switch_favorites" 
                                        :class="board.paperBookmarkId != null ? 'active':''" 
                                        @click="toggleBookmark($event, board)">
                                    즐겨찾기 
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="list-tit-s multi-ellipsis ellipsisdot" @click="moveBoard(board.paperId)"
                        @mouseenter="mouseEvt(true, board, $event)"
                        @mouseleave="mouseEvt(false, board, null)"
                        v-html="board.paperTitle"
                    >
                        <!-- {{board.paperTitle}}  -->
                    </div>
                    <div class="tooltip-b tl small" style="z-index: 11; display: none;" :id="board.paperId+'_tooltip'">
                        <!-- tooltip -->
                        {{ board.paperTitle }}
                    </div>
                    <div class="list-btm clear">
                        <div class="list-see"> 
                            {{board.paperLookupCount > 999 ? '999+': board.paperLookupCount}}
                        </div>
                        <button type="button" class="ico-txt_like heart" 
                                :class="board.paperLikeYN != null ? 'active': ''"
                                @click.stop="setPaperLike(board)">
                            {{board.paperLikeCount > 999 ? '999+':board.paperLikeCount}}
                        </button> 
                        <div class="list-date fr">
                            {{$moment(board.regDate).format("YYYY.MM.DD")}}
                            <span class="ico-new" v-if="board.readCount == null || board.readCount == 0"></span> 
                            <!-- <br />
                            <momentAgo prefix="최종 수정" suffix="전" :date="board.lastUpdDate" lang="kr"></momentAgo>
                            <span class="ico-new" v-if="board.readCount == null || board.readCount == 0"></span> -->
                        </div>
                    </div>
                    
                </li> 
            </ul>
            <div v-if="boardList.length == 0 && !filterYn" class="nodata-txt">
                {{ $i18nUtil.trans("message.SharingContents.001","생성된 정보 보드가 없습니다.") }}
            </div>
            <div v-if="boardList.length == 0 && filterYn" class="nodata-txt">
                {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
            </div>
            <div class="txtc" v-if="boardListFilter.length != 0 && currentPage + 1 < totalPage" @click="moreView">
                <button type="button" class="btn-more-ico_small1 down">{{ $i18nUtil.trans("button.more","더보기") }}</button>
            </div>
        </div>
    </section>
</template>

<script>
import CommonFilterE from "@/components/cowork/common/filter/CommonFilterE";
import { mapState, mapActions, mapMutations } from "vuex";
import RegistBoardMoal from "@/components/cowork/general/cooperation/modal/RegistBoardModal";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
export default {
    props:["category","myUserId","headerNoneRead"], 
    components:{
      CommonFilterE
    },
    data() {
        return {
            /* 보드 리스트 */
            boardList: [], 
            boardListFilter:[],

            selectSort: this.$i18nUtil.trans("entity.paper.search.sort.update","최신순"),
            selectSortBy : 'LAST_UPD_DATE',

            filterBookmark:false,
            noneRead:false,

            paperPerCount : 20,
            totalPage : 0, 
            currentPage : 0,
            totalElements:0,

            newList:[],

            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                    theme: "toasted-primary",
                    position: "bottom-left",
                    duration: 3000,
                },
            },

            categoryManageYn : false,

            changeFilterData : false,
            gradeCodeList: [],
            statusList: [],

            filterYn : false,
            checkIncludeCategoryYn:false
        };
    },
    computed:{
        ...mapState("shareInfo", ["shareInfoManageYn"]),
    },
    watch:{
        category(){  
            this.currentPage = 0;
            this.totalPage = 0;
            this.totalElements = 0; 
            this.selectSort = this.$i18nUtil.trans("entity.paper.search.sort.update","최신순");
            this.selectSortBy = 'LAST_UPD_DATE';
            this.filterBookmark=false,
            this.noneRead=false,
            this.boardList =[];
            this.boardListFilter = []; 
            this.newList=[];
            this.getBoardList();
        },
        headerNoneRead(){
            this.noneRead = this.headerNoneRead; 
        },
        filterBookmark(){
            this.changeFilterData = true;
        },
        noneRead(){
            this.changeFilterData = true;
        },
        changeFilterData(){ 
            if(this.changeFilterData){
                this.currentPage = 0;
                this.totalPage = 0;
                this.totalElements = 0;   
                this.boardList =[];
                this.boardListFilter = []; 
                this.newList=[];
                this.changeFilterData = false;
                if(!this.noneRead && !this.filterBookmark && this.gradeCodeList.length==0 && this.statusList.length == 0){
                    this.filterYn = false;
                }else{
                    this.filterYn = true;
                }
                this.getBoardList();
            }
        },
    }, 
    created(){
        this.checkIncludeCategory();
    },
    mounted(){ 
        this.getBoardList();
    },
    methods: { 
        ...mapMutations("shareInfo", ["setNoneReadCount"]),
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION", "COWORK_REST_ACTION"]),
        ...mapActions("modals", ["showDialog", "showToast", "showModal"]),

        /* 말줄임(...) 시, tooltip 적용 */
        mouseEvt(flag, element, event) {
            let tooltipId = element.paperId+'_tooltip';
            if(flag) {
                // 말줄임(...) css 적용 여부 체크 (boolean)
                let val = this.$tooltip.hasOverflownHeightRemoveClass(event.target, "ellipsisdot");

                if(val) {
                    document.getElementById(tooltipId).style.display = 'block';
                }else{
                    document.getElementById(tooltipId).style.display = 'none';
                };
            }else{
                document.getElementById(tooltipId).style.display = 'none';
            }
        },
        /* 선택된 보드 화면으로 이동 */
        moveBoard(paperId) {
            let state = {
                categoryName : this.category.categoryName,
                categoryMid : this.category.categoryMid
            }
            window.sessionStorage.setItem("shareInfo",JSON.stringify(state));
            let path = "/general/board/" + paperId;
            this.$router.push(path);
        }, 
        getBoardList(){  
            // 미확인 카운트 초기화 
            this.setNoneReadCount(-1); 
            let obj = this;
            let reqData = { 
                url: "/api/copaper/infoshare/getShareBoardListByCategoryMidBylimitCount",
                method: "post",
                params: { 
                    categoryMid: this.category.categoryMid, 
                    page : obj.currentPage, 
                    isFilterBookmark : obj.filterBookmark ? 1 :0,
                    isFilterNoneRead : obj.noneRead ? 1 :0,
                    gradeCodeList: obj.gradeCodeList,
                    statusCodeList: obj.statusList,
                    sortKey : obj.selectSortBy
                },
            };
            //프로그레스바 시작 
            // this.showLoadingbar();
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then((res) => {   
                //프로그레스바 종료
                // this.hideLoadingbar();
                if(res.errorCode != null){
                    console.log(res);
                }else{
                    obj.totalPage = res.result.shareBoardList.totalPages;
                    obj.totalElements = res.result.shareBoardList.totalElements;
                    obj.newList = res.result.shareBoardList.content;
                    for(let k in obj.newList){
                        obj.boardList.splice(obj.boardList.length, 0, obj.newList[k]);
                    }

                    obj.boardListFilter = obj.boardList;
                    if(res.result.categoryUserGrade != null && res.result.categoryUserGrade == "MANAGER"){
                        obj.categoryManageYn = true;
                    }else{
                        obj.categoryManageYn = false;
                    }
                    
                    if(obj.newList.length === 0){  
                        //데이터 없음 .
                        //obj.setNoneReadCount(-1);
                    }else{
                        //보드 상세 정보 API
                        this.getPaperInfoDetail();

                        let noneReadCount = 0;
                        obj.boardList.forEach(function(board){
                            if(board.readCount == null || board.readCount == 0){
                                noneReadCount++;
                            } 
                        })
                        if(noneReadCount != 0 ){
                            obj.setNoneReadCount(noneReadCount);
                        } 
                    }

                    this.multiElipsis(2);
                }
            })
            .catch(function (err) {
                console.log(err);
            });
        },
        getPaperInfoDetail(){ 
            let paperIdList =[];
            this.newList.forEach(function(item){
                paperIdList.push(item.paperId);
            })
            let obj = this;
            let reqData = {};
            reqData.params ={
                paperIdList : paperIdList
            }
            reqData.req = obj.req;
            reqData.url = "/api/copaper/infoshare/getPaperInfoDetail";
            reqData.method = "post";
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(res => { 
                for(let m in res.result.paperInfoList){  
                    for(let k in obj.boardList) { 
                        if(res.result.paperInfoList[m].paperId === obj.boardList[k].paperId){
                            if(obj.boardList[k] != null){  
                                obj.boardList[k].paperLikeYN = res.result.paperInfoList[m].paperLike;
                                obj.boardList[k].paperLikeCount = res.result.paperInfoList[m].paperLikeCount;
                                if(res.result.paperInfoList[m].paperBookmark != null){
                                    obj.boardList[k].paperBookmarkId = res.result.paperInfoList[m].paperBookmark.paperBookmarkId;
                                }
                            }
                            break;
                        }     
                    }
                }   
            })
            .catch(function(err) {
                console.log(err);
            });
      
        },
        /* 선택된 보드 찜 등록 및 해제(1: 찜 / 2: 해제) */
        toggleBookmark(event, item) {
            event.target.classList.toggle("active");
            let obj = this;
            let reqData = {};
            reqData.params ={
                paperId: item.paperId,
                bookmarkId: item.paperBookmarkId
            }
            reqData.req = obj.req;
            reqData.url = "/api/copaper/bookmark/savePaperBookmark";
            reqData.method = "post";
            obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => {   
                    obj.boardList.forEach(function(board){
                        if(board.paperId == item.paperId){
                            board.paperBookmarkId = res.result;
                        }
                    }) 
                    if(res.result == null){
                        //즐겨찾기 해제
                        this.toastInfo.message = this.$i18nUtil.trans("TB042");
                        this.showToast(this.toastInfo); 
                    }else{
                        //즐겨찾기   
                        this.toastInfo.message = this.$i18nUtil.trans("TB041");
                        this.showToast(this.toastInfo); 
                    }
                }) 
                .catch(function(err) {
                console.log(err);
                }); 
        },
        setPaperLike(list){
            event.target.classList.toggle("active");
            let obj = this;
            let reqData = {
                url: "/api/copaper/infoshare/setPaperLike",
                method: "post",
                params: {
                paperId: list.paperId, 
                },
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (res) { 
                if (res.errorCode != null) {
                    console.log(res.errorCode);
                } else { 
                    obj.boardList.forEach(function(item){
                        if(item.paperId == list.paperId){
                            item.paperLikeCount = res.result.paperLikeCount;
                            if(res.result.paperLike != null){
                                item.paperLikeYN = res.result.paperLike;
                            } 
                        }
                    }) 
                }
            })
            .catch(function (err) {
                console.log(err);
            }); 
        },
        addBoard(){ 
            let obj = this;
            let reqData = {};
            reqData.req = obj.req;
            reqData.url = "/api/copaper/paper/getGeneratedPaperId";
            reqData.method = "post";

            obj
            .COWORK_REST_ACTION(reqData)
            .then(function (res) {
                let errorCode = res.errorCode;
                let addPaperId = res.result;
                const modalInfo = {
                    title: obj.$i18nUtil.trans("button.paper.shar.add","정보 보드 추가"),
                    name: "RegistShareInfoBoard",
                    method: "post",
                    width: "800px",
                    // height: "493px",
                    obj: obj.$modal, 
                    contentPath: "",
                    component: RegistBoardMoal,
                    paperId:addPaperId, 
                    selectedCategoryMid: obj.category.categoryMid,
                    selectedCategory : obj.category
                }; 
                obj.showModal(modalInfo);
            })
            .catch(function (err) {
                console.log(err);
            });       
        },
        fSelectSort(event){  
            event.target.parentElement.parentElement.parentElement.childNodes[0].classList.toggle('active'); 
            let obj = this;
            let filter = event.target.value;
            this.selectSort = event.target.name;
            let childNodes = event.target.parentElement.parentElement.parentElement.getElementsByTagName('button');     
            for(let k in childNodes){ 
                if(childNodes[k].nodeName == "BUTTON"){
                    childNodes[k].classList.remove('active');
                }
            }
            // -- 최신순 : LAST_UPD_DATE  조회수순 : PAPER_LOOKUP_COUNT  좋아요순 : PAPER_LIKE_COUNT  
            if(filter == "lastest"){
                // 최신 순
                event.target.classList.toggle('active');
                this.selectSortBy = "LAST_UPD_DATE";
                // this.boardListFilter.sort(function(board1, board2){ 
                    //      return obj.$moment(board2.lastUpdDate).format("YYYYMMDDHHMMSS") - obj.$moment(board1.lastUpdDate).format("YYYYMMDDHHMMSS");
                // })
            }else if(filter == "views"){
                // 조회수 순
                event.target.classList.toggle('active');
                this.selectSortBy = "PAPER_LOOKUP_COUNT";
                // this.boardListFilter.sort(function(board1, board2){ 
                    //      return board2.paperLookupCount - board1.paperLookupCount;
                // })
            }else{
                // 좋아요 순 
                event.target.classList.toggle('active');
                this.selectSortBy = "PAPER_LIKE_COUNT";
                // this.boardListFilter.sort(function(board1, board2){ 
                //      return board2.paperLikeCount - board1.paperLikeCount;
                // })
            }

             this.changeFilterData = true;
        }, 
        moreView(){
            this.currentPage ++;
            this.getBoardList();
        },
        multiElipsis(ellipsisLine) { 
            this.$nextTick(function(){
                let selecter = "multi-ellipsis";
                var omle = document.getElementsByClassName(selecter); 
                for(let item of omle){
                    if (item.scrollHeight > 55) {
                        item.classList.remove("no-ellipsis");
                    } else {
                        item.classList.add("no-ellipsis");
                    }
                } 
            })
        }, 
        updateCommonFilterE(filterData){
            this.gradeCodeList = filterData.filterGradeList;
            this.statusList = filterData.filterStatusList;
            if(this.gradeCodeList.length == 3){
                this.gradeCodeList = [];
            }
            if(this.statusList.length == 4){
                this.statusList =[];
            }
            this.changeFilterData = true;
        },
        checkIncludeCategory(){
            let obj = this;
            let reqData = {};
            reqData.params ={}
            reqData.req = obj.req;
            reqData.url = "/api/copaper/infoshare/checkIncludeCategory";
            reqData.method = "post"; 
            obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => { 
                    if(res.result.checkCategoryCount){
                        obj.checkIncludeCategoryYn = true;
                    }else{
                        obj.checkIncludeCategoryYn = false;
                    }
                })
                .catch(function(err) { console.log(err); });
        },
        goBoardManage(){
            if(this.checkIncludeCategoryYn){
                let path = "/general/shareInfoBoardManage";
                this.$router.push(path);
            }else {
                const dialogInfo = {
                    obj: this.$modal,
                    component: Dialog,
                    title : this.$i18nUtil.trans("title.dialog.notice","알림"),
                    button : this.$i18nUtil.trans("button.dialog.confirm","확인"),
                    contents : this.$i18nUtil.trans("AB102"),
                };
                this.showDialog(dialogInfo);
            }
        }
    }
};
</script>

<style lang="css" scoped> 
.multi-ellipsis {
  overflow: hidden;
  position: relative;
  line-height: 1.44;
  text-align: justify;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.multi-ellipsis:before,
.multi-ellipsis:after {
  content: "...";
  line-height: 1;
  position: absolute;
  right: 0;
  top: 1.44em;
  -ms-wrap-flow: start;
}
.multi-ellipsis:after {
  background: currentColor !important;
  color: #fff !important;
  top: auto;
}
.multi-ellipsis.no-ellipsis::before,
.multi-ellipsis.no-ellipsis::after {
  display: none;
}
@supports (-webkit-line-clamp: 2) {
  .multi-ellipsis {
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .multi-ellipsis::before,
  .multi-ellipsis::after {
    content: normal;
  }
}
.ellipsisdot {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    box-orient: vertical;
    -webkit-box-orient: vertical;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/shareInfo/base/SharingContents.vue